import EnterprisesRouter from './EnterpriseRouter.router';

export default EnterprisesRouter;
